
/* injects from baggage-loader */

const moduleEditor = angular.module('editorLesson.controller', ['api.widget', 'factory.editorLibrary']);

moduleEditor.controller("EditorLessonCtrl", [
  "$scope", "$rootScope", "$state", "$timeout", "editorNavSections", "layoutEditor", "Widget", "insertBlockMenu", "Template", "ns", "Lesson", "editorDragPanel", "SectionLesson", "$modal", "State", "blockOverlays", "Font", "TimeMachine", "Notification", "$filter", "Parallax", "WidgetsSortHelper", "EditorLibrary",
  ($scope, $rootScope, $state, $timeout, editorNavSections, layoutEditor, Widget, insertBlockMenu, Template, ns, Lesson, editorDragPanel, SectionLesson, $modal, State, blockOverlays, Font, TimeMachine, Notification, $filter, Parallax, WidgetsSortHelper, EditorLibrary) => {

    let stylesCallback = undefined;

    $scope.templateIsReady = false;
    $rootScope.filter = $filter;
    $rootScope.justclick = window.justclick;

    /**
     * Template style manipulation
     * @param sectionId
     */
    const loadStylesOfTemplate = (sectionId = false) => {
      Template.getStylesheet().then((response) => {
        angular.element("#tplStyles").text(response);
        if (stylesCallback) {
          stylesCallback();
          stylesCallback = undefined;
        }
      });
    };

    /**
     * loadStylesOfPublicSection
     */
    const loadStylesOfPublicSection = () => {
      SectionLesson.getPublicSectionStylesheet().then((response) => {
        angular.element("#tplStyles").text(response);
      })
    };

    /**
     * loadStyles
     * @param sectionId
     */
    const loadStyles = (sectionId = false) => {
      if ($state.includes("editor.section")) {
        loadStylesOfPublicSection();
      } else {
        loadStylesOfTemplate(sectionId);
      }
    };

    /**
     * destroyGetStyles $on "get:styles"
     */
    const destroyGetStyles = $rootScope.$on("get:styles", (data, sectionId, cb) => {
      if (cb) {
        stylesCallback = cb;
      }

      loadStyles(sectionId);
    });

    /**
     * addAdditionalFonts
     */
    const addAdditionalFonts = () => {
      if (Editor.mode === "editor.section") {
        Editor.Instrumentations.fonts = $rootScope.sections.fonts_attributes;
      }
      if (Editor.mode === "lesson.page.editor") {
        Editor.Instrumentations.fonts = $rootScope.site.fonts_attributes.concat(Font.defaultLessonFonts);
      }
      $rootScope.$broadcast("fontNames:loaded");
    };

    /**
     * Auto start edit section
     */
    const startEditPublicSection = () => {
      if (Editor.mode === "editor.section") {
        const layout = $rootScope.Y.one(ns.sectionClass);
        return editorDragPanel._onClickEditSection({
          target: layout
        });
      }
    };

    /**
     * Remove auto play on videos
     * @param htmlData
     * @returns {string}
     */
    const removeAutoPlay = (htmlData) => {
      if (!htmlData) {
        return "";
      }

      return htmlData.replace(new RegExp("autoplay=1", 'g'), "");
    };

    /**
     * Set event preventDefault
     * @param e
     */
    const preventForm = (e) => {
      e.preventDefault();
    };

    /**
     * Disable submit forms
     */
    const preventFormsSubmit = () => {
      angular.element("body").on("submit", "form", preventForm);
    };

    /**
     * Enable submit forms
     */
    const unbindPreventForm = () => {
      angular.element("body").off("submit", "form", preventForm);
    };

    /**
     * Parse sections html
     * @param selector
     * @param htmlString
     * @returns {*}
     */
    const parseHTML = (selector, htmlString) => {
      const codeHTML =
        "<div class='str-bw_code-html-overlay'>" +
          "<img class='str-bw_code-html-overlay-icon' src='/constructor/editor/assets/images/code-overlay-icon.svg' />" +
          `<div class='str-bw_code-html-overlay-text'>${$filter('translate')('widget.code.text')}</div>` +
        "</div>";

      let contentSectionsHTML = "";
      const jContent = $('<div/>').html(htmlString).contents();

      jContent.find(".str-bw_code-html").html(codeHTML);

      if (selector !== "section" && jContent.find(selector)[0]) {
        return jContent.find(selector)[0].outerHTML;
      }
      if (selector === "section") {
        jContent.find("section").each((index, section) => {
          return contentSectionsHTML += section.outerHTML;
        });
        return contentSectionsHTML;
      }
    };

    /**
     * Insert sections html to wrapper
     * @param htmlData
     * @returns {boolean}
     */
    const setTemplateHTML = (htmlData) => {
      if (Editor.mode === "editor.section") {
        $("#tpl-wrapper").html(htmlData);
        return false;
      }
      htmlData = `<div>${htmlData}</div>`;

      const headerHTML = parseHTML("header", htmlData);
      const footerHTML = parseHTML("footer", htmlData);
      const contentSectionsHTML = parseHTML("section", htmlData);

      $(headerHTML).insertBefore(".str-drop-backdrop");
      $(footerHTML).insertAfter(".str-drop-backdrop");
      $(contentSectionsHTML).insertAfter(".str-drop-backdrop");
      EditorLibrary.removeVisibilityDelay();
    };

    /**
     * Callback after instruments initialized
     */
    const afterInstrumentsInitialized = () => {
      preventFormsSubmit();
      Template.loadHTML().then((htmlData) => {
        htmlData = removeAutoPlay(htmlData);

        // try set html to Template from server
        try {
          setTemplateHTML(htmlData);
        } catch (e) {
          log(e);
        }

        // set Y instace to layoutEditor class
        layoutEditor.initializer($rootScope.Y);

        // load json sections and set to YUI DOM objects
        Template.loadJSON().then((data) => {

          $rootScope.contentSections = _.filter(data, {section_type: "default"});
          $rootScope.sections = data;

          layoutEditor.setTemplateJSON(data);

          editorDragPanel.initSectionsPanels($rootScope.Y, Editor.mode);
          blockOverlays.init($rootScope.Y);
          addAdditionalFonts();
          $rootScope.toggleCommonSections();
          layoutEditor.sectionInitializers($rootScope.Y);
          $rootScope.checkInteractiveBlocks();

          $timeout(() => {
            $scope.templateIsReady = true
          }, 1000);

          $timeout(() => {
            startEditPublicSection();
          });
        })
      }, () => {
        $rootScope.alertDialog({
          title: $filter("translate")("alert.editor.error"),
          text: $filter("translate")("alert.editor.errorDescription"),
          accept_text: "OK",
          accept: () => {
            if (["admin", "superadmin"].includes(window.justclick.currentUser.role)) {
              document.location.href = "/sites/constructor/admin/#/admin/dashboard/templates";
            } else {
              document.location.href = window.justclick.back_uri;
            }
          }
        });
      });
    };

    const pageLmsStyling = () => {
      if (!!window.justclick.lms === false) {
        return false;
      }

      const headerHtml = window.justclick.lms.header;
      const footerHtml = window.justclick.lms.footer;

      const $header = angular.element(".e__lesson__header");
      const $footer = angular.element(".e__lesson__footer");

      $header.html(headerHtml);
      $footer.html(footerHtml);

      Lesson.getLmsStylesheets().then((response) => {
        angular.element("#lmsStyles").html(response);
      });
    };

    /**
     * Create class editor
     */
    const Editor = {
      initializer: () => {
        if (Editor.mode === 'lesson.page.mixer') {
          Editor.option = 'lesson.page.mixer';
          Editor.mode = 'lesson.page.editor';
        }

        // Get json of site and load styles
        if (Editor.mode === "lesson.page.editor") {
          pageLmsStyling();

          Lesson.get($state.params.lessonId).then((siteData) => {
            $rootScope.currentSite = siteData;
            $rootScope.currentPage = getJsonCurrentPage(siteData);
            $rootScope.Y.one("#tpl-wrapper").section = $rootScope.currentPage;
            setBgStyles();
            loadStyles();
          }, () => {
            $state.go("404");
          });
        }
        if (Editor.mode === "editor.section") {
          loadStyles();
        }
        // init instruments for editor
        Editor.Instrumentations.initializer(afterInstrumentsInitialized);
      },
      mode: $state.current.name,
      getSections: () => {
        const sections = [];
        const domSections = $rootScope.Y.all(ns.sectionClass);

        domSections.each((s) => {
          // Установим правильную секцию при получении списка секций, если необходимо
          const previousSection = layoutEditor.getRootScopeParameter('previousSection', s.section.id);
          if (!s.section.removed && !!previousSection && !_.isEqual(previousSection, s.section)) {
            s.section = previousSection;
          }

          sections.push(s.section);
        });

        return sections;
      },
      destroy: () => {
        layoutEditor.destroy();
      },
      // Editor instrumentations
      Instrumentations: {
        defaultFonts: Font.defaults,
        widgetList: [],
        approvedWidgetsList: [
          // "product",
          "button",
          // "form",
          "subscribe_form",
          "image",
          "line",
          "link",
          "spacer",
          "text",
          "headline_h1",
          "headline_h2",
          "headline_h3",
          "video",
          "navigation",
          "card",
          "code",
          "gallery",
          "slider",
          "review",
          "map",
          "social",
          // "timer",
          "table",
          "list",
        ]
      }
    };

    /**
     * Editor instrumentations initializer
     * @param cb
     */
    Editor.Instrumentations.initializer = (cb) => {
      const self = Editor.Instrumentations;

      const widgetsTypesSortMap = [
        'headline_h1','headline_h2','headline_h3',
        'text', 'spacer', 'subscribe_form',
        'image', 'video', 'button',
        'list', 'timer', 'code',
        'navigation', 'link', 'review',
        'card', 'product', 'slider',
        'gallery', 'table', 'line',
        'map', 'social', 'facebook_comment'
      ];

      // Загрузка виджетов, использование только тех виджетов, которые указаны в массиве approvedWidgetsList
      Widget.getAll().then((widgetsData) => {
        _.each(widgetsData.widgets, (widget) => {
          if (self.approvedWidgetsList.includes(widget.type)) {
            self.widgetList.push(widget);
          }
        });

        self.widgetList = WidgetsSortHelper.sortWidgetsByTypesSortMap(self.widgetList, widgetsTypesSortMap)

        $timeout(() => {
          cb();
        });
      });
    };

    // set Editor globally
    $rootScope.Editor = Editor;
    window.Editor = Editor;


    /**
     * setGradient
     * @param background_attributes
     */
    const setGradient = (background_attributes) => {
      const color_start = background_attributes.color_start;
      const color_stop = background_attributes.color_stop;
      const gradient_css =
        `background-image:-moz-linear-gradient(top, ${color_start}, ${color_stop});` +
        `background-image:-webkit-linear-gradient(top, ${color_start}, ${color_stop});` +
        `background-image:-o-linear-gradient(top, ${color_start}, ${color_stop});` +
        `background-image:-ms-linear-gradient(top, ${color_start}, ${color_stop});,` +
        `background-image:linear-gradient(top, ${color_start}, ${color_stop});` +
        `filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='${color_start}', endColorstr='${color_stop}');"`;

      const $style = $(`style#${$rootScope.currentPage.id}`);

      if ($style.length > 0) {
        $style.html(`#tpl-wrapper:before { ${gradient_css} }`);
      } else {
        $('body').append(`<style id='${$rootScope.currentPage.id}'>#tpl-wrapper:before { ${gradient_css} }</style>`);
      }
    };

    /**
     * setBgStyles
     */
    const setBgStyles = function() {
      const bodyElement = $("#tpl-wrapper");
      bodyElement.css($rootScope.currentPage.style_attributes);
      const imageExist = $rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.image_attributes && $rootScope.currentPage.background_attributes.image_attributes.source_url;
      if (imageExist) {
        bodyElement.css({
          backgroundImage: "url('" + $rootScope.currentPage.background_attributes.image_attributes.source_url + "')"
        });
      }
      if ($rootScope.currentPage.background_attributes && $rootScope.currentPage.background_attributes.gradient) {
        setGradient($rootScope.currentPage.background_attributes);
      }
      Parallax.initSection($rootScope.Y.one("#tpl-wrapper"));
    };

    /**
     * Get json current page
     * @param site
     * @returns {undefined}
     */
    const getJsonCurrentPage = (site) => {
      let currentPage = undefined;

      const pageId = $state.params.pageId;
      const parentPagesResult = _.filter(site.pages, {path: $state.params.pageId})[0];

      if (parentPagesResult) {
        currentPage = parentPagesResult
      }

      site.pages.forEach((page) => {
        page.pages.forEach((pageChild) => {
          if (pageChild.path === pageId) {
            currentPage = pageChild;
          }
        });
      });

      return currentPage;
    };

    /**
     * Init drag&drop widgets in widget menu after render
     */
    const destroyWidgetsFinished = $scope.$on("widgetsFinished", (newData) => {
      insertBlockMenu.initDD()
    });

    /**
     * Destroy instances when exit from editor
     */
    $scope.$on("$destroy", () => {
      unbindPreventForm();
      destroyGetStyles();
      destroyWidgetsFinished();
      Editor.destroy();
      TimeMachine.destroy();
      $rootScope.widgetIsEditing = false;
      $scope.templateIsReady = false;
    });

    // Connect and initialize YUI library Y instance, Editor initialize, Instrumentations init
    if (!$rootScope.Y) {
      YUI().use('node', 'event-valuechange', 'anim', 'dd', 'dd-proxy', 'dd-constrain', 'dd-drop', 'dd-scroll', "dd-delegate", "event-hover", "resize", "resize-plugin", "overlay", (y) => {
        $rootScope.Y = y;
        Editor.initializer();
      });
    } else {
      Editor.initializer();
    }

    /**
     * Show or hide drop overlays of footer or header
     * @param sections
     */
    $rootScope.toggleCommonSections = (sections) => {
      sections = Editor.getSections();
      const headers = _.filter(sections, {section_type: "header"});
      const footers = _.filter(sections, {section_type: "footer"});

      $scope.showFooter = !footers.length;
      $scope.showHeader = !headers.length;
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    };

    $scope.viewSite = State.viewSite;
    $scope.saveSection = editorDragPanel.cancelSection;

    $rootScope.openEditorNavPanel = () => {
      $(".etsw-header__title").text($filter('translate')('editor.addElementButton'));
      $scope.editorNavOpen = true;
    };

    $scope.openEditorNav = () => {
      $rootScope.editorNavTab("sections");
      $rootScope.openEditorNavPanel();
    };

    $scope.panelRight = true;
    $scope.togglePanelPosition = () => {
      $scope.panelRight = !$scope.panelRight;
    };

    $rootScope.undo = function() {
      $timeout(function () {
        TimeMachine.undo();
      });
    };
    $rootScope.redo = function() {
      $timeout(function () {
        TimeMachine.redo();
      });
    };

    /**
     * save preview
     */
    $rootScope.savePreview = () => {
      $scope.loading = true;

      const sections = Editor.getSections();
      layoutEditor.sortSections()
      SectionLesson.saveAllSectionsAndPublishPreview(sections).then((response) => {
        if (response.status && (typeof response.data !== "undefined" && response.data !== null) && (typeof response.data.preview_lms_page_id !== "undefined" && response.data.preview_lms_page_id !== null)) {
          $scope.loading = false;
          $rootScope.openPreview(response.data.preview_lms_page_id);
        }
      }, () => {
        $scope.loading = false;
        Notification.error({message: $filter('translate')('site.error')});
      })
    };

    /**
     * publish site
     */
    $rootScope.publishSite = () => {
      $timeout(() => {
        $scope.publishing = true;

        const sections = Editor.getSections();
        layoutEditor.sortSections()
        SectionLesson.saveAllSectionsAndPublish(sections).then((sectionsData) => {
          EditorLibrary.showBuildStatus(SectionLesson, $scope, null, 3000, 3000, 3);

          TimeMachine.clear();
          layoutEditor.setTemplateJSON(sectionsData);
          $timeout(() => {
            $scope.publishing = false;
            Notification.success({message: $filter('translate')('site.saved')});
          });
        }, () => {
          $scope.publishing = false;
          Notification.error({message: $filter('translate')('site.error')});
        });
      }, 300);
    };

    /**
     * section save
     */
    $scope.sectionSave = () => {
      $scope.sectionSaving = true;
      layoutEditor.publicSectionSave().then(() => {
        $scope.sectionSaving  = false;
      });
      return;
    };

    /**
     * Exit from editor
     */
    $scope.exit = () => {
      $rootScope.alertDialog({
        title: $filter("translate")("alert.editor.exitTitle"),
        text: $filter("translate")("alert.editor.exitDescription"),
        accept_text: $filter("translate")("alert.confirm"),
        cancel_text: $filter("translate")("alert.cancel"),
        accept: () => {
          if (["admin", "superadmin"].includes(window.justclick.currentUser.role)) {
            $state.go("admin.dashboard.templates");
          } else {
            document.location.href = window.justclick.back_uri;
          }
        }
      })
    };

    $rootScope.checkInteractiveBlocks = function() {
      if (Editor.mode !== 'lesson.page.editor') {
        return false;
      }

      $scope.intBlocksExists = false;
      Editor.getSections().forEach(function(section) {
        if (section.interactive) {
          $scope.intBlocksExists = true;
        }
      });

      $rootScope.Y.all('.str-block').each(function(block) {
        if (block.widget && block.widget.interactive) {
          $scope.intBlocksExists = true;
        }
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/editorLesson.controller.js